import { module } from 'modujs'
import SurveyResultsMixin from '../utils/vue/mixins/SurveyResultsMixin'
import MediaModal from '../utils/vue/components/MediaModal'
import { GtagHandler } from '../app'

export default class SurveyViolenceResults extends module {

    static get settings() {
        return {
            contentKeys: ['contentNo', 'contentYes', 'contentYesRedFlags']
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
    }

    init() {
        var that = this

        this.app = new Vue({
            el: this.$el,
            mixins: [ SurveyResultsMixin ],
            components: {
                MediaModal
            },
            data: () => ({
                LSQModal: {
                    src: null,
                    title: null,
                }
            }),
            created() {
                this.fetchData('surveyViolenceResults')

                GtagHandler.emit('surveyComplete')
            },
            computed: {
                results() {
                    return this.rawResults.filter(item => (item.answer !== 'false' && !!item.answer))
                },
                hasViolence() {
                    return this.results.findIndex(item => typeof item.violenceType !== 'undefined') > -1
                },
                hasRedFlag() {
                    return this.results.findIndex(item => item.isRedFlag) > -1
                },
                contentKey() {
                    if(this.hasViolence && this.hasRedFlag) {
                        return SurveyViolenceResults.settings.contentKeys[2]
                    } else if(this.hasViolence) {
                        return SurveyViolenceResults.settings.contentKeys[1]
                    } else {
                        return SurveyViolenceResults.settings.contentKeys[0]
                    }
                },
                lsqSrc() {
                    if (!this.hasViolence) {
                        return 'https://d1wk6pxuc6l766.cloudfront.net/no-violent-behavior.mp4'
                    } else if(!this.hasViolence && !this.hasRedFlag) {
                        return 'https://d1wk6pxuc6l766.cloudfront.net/some-violent-behavior.mp4'
                    } else if(this.hasViolence && this.hasRedFlag) {
                        return 'https://d1wk6pxuc6l766.cloudfront.net/violent-behavior.mp4'
                    }

                    return null
                },
                LSQModalIsOpen() {
                    return this.LSQModal.src !== null
                },
                // JSON results for SendSurvey Component
                emailContent() {
                    console.log(this.rawResults);
                    return {
                        data: this.results
                    }
                },
            },
            methods: {
                toggleWidget() {
                    that.call('toggleWidget', 'WidgetUser')
                    GtagHandler.emit('surveySpeakAssistant')
                },
                toggleLSQModal(src = null, title = null) {
                    this.LSQModal.src = src
                    this.LSQModal.title = title
                    this.$refs.lsq?.pause()
                },
                nextSurvey() {
                    GtagHandler.emit('startNewSurveyControl')
                }
            }
        })
    }

    destroy() {
        if (this.app) {
            this.app.$destroy()
        }
    }
}
